module.exports = __webpack_public_path__ + "img/pin-6000.d1c078da.png";